import { render } from "./InventarioPage.vue?vue&type=template&id=31425404"
import script from "./InventarioPage.vue?vue&type=script&lang=js"
export * from "./InventarioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__